export interface ValidityApplicationPeriod {
  start: string;
  end: string | null;
}

export interface Date {
  year: number;
  month: number;
  day: number;
}

export const validityApplicationWeekdays = [
  { value: 'MO', displayName: 'Mondays' },
  { value: 'TU', displayName: 'Tuesdays' },
  { value: 'WE', displayName: 'Wednesdays' },
  { value: 'TH', displayName: 'Thursdays' },
  { value: 'FR', displayName: 'Fridays' },
  { value: 'SA', displayName: 'Saturdays' },
  { value: 'SU', displayName: 'Sundays' }
];
